<template>
  <div class="containerTable" style="position: relative;">
    <vxe-toolbar
      :id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="management_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('management_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
        <el-button
          v-if="shipment.isPayPermission === 1"
          @click="getSelectEvent"
        >
          批量打款
        </el-button>
      </template>
    </vxe-toolbar>
    <div style="position: absolute;top: 15px;right: 107px;">
      预付运费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedShipmentDeliveryFeePracticalSum || "--" }}
      </span>
    </div>
    <vxe-table
      :key="tableKey"
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
      @checkbox-change="updateSelectedFeeSum"
      @checkbox-all="updateSelectedFeeSum"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column v-if="isSub">
        <vxe-table-column
          field="companyName"
          title="子公司名称"
          min-width="200"
          sortable
          fixed="left"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入子公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入"
            clearable
            @focus="batchInputDialogVisible = true"
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="prepaidStatus"
          title="预付状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'prepaidStatus')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.prepaidStatus"
            placeholder="请选择"
            clearable
            :disabled="prepaidStatus !== ''"
          >
            <el-option
              v-for="item in parentData.prepaidStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="预付金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="payOil"
          title="已预付油点"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.payOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="allotTaxAmount"
          title="托运人实付"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allotTaxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allotTaxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人联系手机号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="银企收款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入收款人名称"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="承运车队"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="承运人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-cascader
            clearable
            :options="goodsTypeList"
            :show-all-levels="false"
            :props="{ expandTrigger: 'hover', value: 'code' }"
            @change="handleChangeCoalType"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装车重量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸车重量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="货物数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPrice"
          title="托运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="realPrice"
          title="实际承运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="公里数"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="taxFee"
          title="托运人预估运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="实际承运人预估运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="收货地址"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="装车截止时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装货时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="management_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!--  在线支付-->
          <el-tooltip
            v-if="
              prepaidManagement_payOnline_button &&
                isAdmin &&
                (scope.row.prepaidStatus == 1 ||
                  scope.row.isMonthlyOrder == 1) &&
                shipment.isPayPermission === 1
            "
            class="item"
            effect="dark"
            content="在线预付"
            placement="top"
          >
            <vxe-button type="text" @click="payOnline(scope.row)">
              <em class="el-icon-shopping-cart-2" />
            </vxe-button>
          </el-tooltip>

          <el-tooltip
            v-if="
              management_shipment_button &&
                scope.row.isMonthlyOrder == 0 &&
                prepaidStatus === 0 &&
                shipment.isPayPermission === 1 &&
                ((shipment.staffType !== 10 && isSub) || !isSub)
            "
            class="item"
            effect="dark"
            content="托运人预付"
            placement="top"
          >
            <vxe-button type="text" @click="ReloadingShipmentMoney(scope.row)">
              <em class="el-icon-coin" />
            </vxe-button>
          </el-tooltip>
          <template
            v-if="
              isAdmin &&
                (scope.row.prepaidStatus == 1 ||
                  scope.row.isMonthlyOrder == 1) &&
                shipment.isPayPermission === 1
            "
          >
            <el-tooltip
              v-if="management_money_button"
              class="item"
              effect="dark"
              content="预付现金"
              placement="top"
            >
              <vxe-button type="text" @click="ReloadingMoney(scope.row)">
                <em class="el-icon-s-claim" />
              </vxe-button>
            </el-tooltip>
            <!-- <el-tooltip
              v-if="management_oil_button"
              class="item"
              effect="dark"
              content="预付油点"
              placement="top"
            >
              <vxe-button
                type="text"
                @click="ReloadingOil(scope.row)"
              >
                <em class="el-icon-sort" />
              </vxe-button>
            </el-tooltip> -->
            <el-tooltip
              v-if="management_cash_button && shipment.isPayPermission === 1"
              class="item"
              effect="dark"
              content="转账支付"
              placement="top"
            >
              <vxe-button type="text" @click="ReloadingCash(scope.row)">
                <em class="el-icon-bank-card" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="management_blank_button && shipment.isPayPermission === 1"
              class="item"
              effect="dark"
              content="银行支付"
              placement="top"
            >
              <vxe-button type="text" @click="ReloadingBlank(scope.row)">
                <em class="el-icon-bank-card" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="yufudelMoney"
      title="预付现金"
      width="600"
      height="520"
      resize
      @close="close"
    >
      <payadvanceMoney ref="yufuMoneyRef" @closeWindows="receive" />
    </vxe-modal>
    <vxe-modal
      v-model="yufudelOil"
      title="预付油点"
      width="600"
      height="580"
      resize
    >
      <payadvanceOil ref="yufuOilRef" @closeWindows="receive" />
    </vxe-modal>
    <vxe-modal
      v-model="shipmentyufudelMoney"
      title="托运人预付"
      width="600"
      height="340"
      resize
    >
      <!-- <payadvanceShipmentMoney
        ref="shipmentyufuMoneyRef"
        @closeWindows="receive"
      /> -->
      <paymentAction
        v-if="shipmentyufudelMoney"
        ref="shipmentyufuMoneyRef"
        @closeWindows="receive"
        @error="shipmentyufudelMoney = false"
      />
    </vxe-modal>
    <payadvanceCash
      ref="payadvanceCash"
      :parent-data="parentData"
      @onSuccess="findList"
    />
    <payadvanceBlank
      ref="payadvanceBlank"
      :parent-data="parentData"
      @onSuccess="findList"
    />
    <vxe-modal
      v-model="payOnlineFlag"
      title="在线预付"
      width="800"
      height="700"
      resize
    >
      <payOnline ref="payOnlineRef" @payOnlineclose="payOnlineclose" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      />
    </el-dialog>
  </div>
</template>
<script>
import BatchWaybill from "@/components/BatchWaybill";
import ordergoods from "@/components/WaybillDetails";
import payadvanceMoney from "./components/payadvanceMoney.vue";
import { getLimit } from "@/utils/getLimit.js";
// import payadvanceShipmentMoney from "./components/payadvanceShipmentMoney.vue";
import paymentAction from "./components/paymentAction.vue";
import payadvanceOil from "./components/payadvanceOil.vue";
import payadvanceBlank from "./components/payadvanceBlank.vue";
import payOnline from "./components/payOnline.vue";
import payadvanceCash from "./components/payadvanceCash.vue";
import { orderDetailListAll, querySubList } from "@/api/transport";
import { getGoodsTypeDict } from "@/api/shipment";
import { preApplicationForPrepay } from "@/api/InternetBanking";
export default {
  name: "Management",
  components: {
    BatchWaybill,
    ordergoods,
    payadvanceMoney,
    payadvanceOil,
    payadvanceBlank,
    payadvanceCash,
    paymentAction,
    // payadvanceShipmentMoney,
    payOnline
  },
  props: {
    prepaidStatus: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      isHasSub: this.$store.state.user.party.companyType,
      shipment: this.$store.getters.shipment || { isPayPermission: 1 },
      batchInputDialogVisible: false,
      selectedShipmentDeliveryFeePracticalSum: 0,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportDetailPrePay", //导出接口
        name: "预付运费"
      },
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      loading: false,
      tuteship: false,
      yufudelMoney: false,
      yufudelOil: false,
      payOnlineFlag: false,
      shipmentyufudelMoney: false,
      management_search_button: false, //查询
      management_detail_button: false, //详情
      management_shipment_button: false, //托运人预付
      management_money_button: false, //预付现金
      management_oil_button: false, //预付油点
      management_blank_button: false, //银行支付
      management_cash_button: false, //转账支付
      prepaidManagement_payOnline_button: false, // 在线支付
      areaOptions: this.$store.state.components.areaOptions,
      tableData: [],
      parentData: {},
      consignorAreaList: [],
      consigneeAreaList: [],
      goodsTypeList: [],
      listQuery: {
        lastLoadingTimeRange: "",
        gmtCreatedRange: "",
        fillTimeRange: "",
        gmtModifiedRange: "",
        shipType: "prePay",
        //isUnloadingConfirm: 0,
        prepaidStatus: "",
        greaterStatus: 1,
        lessStatus: 7,
        // isSettle: 0,
        isLoadingConfirm: 1,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        isFill: 1,
        deleted: 0
      },
      // Pagingconf: [],
      sumObject: {},
      // 机构列表
      branchList: this.$store.state.components.branchList,
      isAdmin: false
    };
  },
  computed: {
    isSub() {
      return this.$route.path.includes("sub_management");
    },
    toolbarId() {
      const path = (this.$route.path || "").replace(/\//g, "_");
      return `toolbar_tablePre${path ? "_" + path : ""}_${
        this.prepaidStatus === "" ? "all" : this.prepaidStatus
      }`;
    },
    tableKey() {
      return `tablePre_${(this.$route.fullPath || "").replace(
        /[/?=&]/g,
        "_"
      )}_${this.prepaidStatus === "" ? "all" : this.prepaidStatus}`;
    }
  },
  watch: {
    "$route.fullPath": {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return;
        const v = this.$route.query.todo;
        this.listQuery = {
          lastLoadingTimeRange: "",
          gmtCreatedRange: "",
          fillTimeRange: "",
          gmtModifiedRange: "",
          shipType: "prePay",
          //isUnloadingConfirm: 0,
          prepaidStatus: "",
          greaterStatus: 1,
          lessStatus: 7,
          // isSettle: 0,
          isLoadingConfirm: 1,
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0,
          isFill: 1,
          deleted: 0
        };
        this.listQuery.prepaidStatus = v ? 1 : this.prepaidStatus;
        this.selectedShipmentDeliveryFeePracticalSum = 0;
        this.$nextTick(() => {
          const table = this.$refs.xTable;
          if (!table) return;
          if (table.clearSort) table.clearSort();
          if (table.clearCheckboxRow) table.clearCheckboxRow();
        });
        this.findList();
      }
    }
  },
  created() {
    this.roles = this.$store.getters.roles;
    if (
      this.roles.indexOf("PLAT_ADMIN") > -1 ||
      this.roles.indexOf("STAFF") > -1
    ) {
      this.isAdmin = true;
    }
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.prepaidStatus = 1;
    }
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.parentData.prepaidStatusOptions = [
      { label: "未预付", value: 0 },
      { label: "预付中", value: 1 },
      { label: "已完成", value: 2 }
    ];
    // 货物类型
    getGoodsTypeDict({ parentCode: "goodsBigType" }).then(response => {
      this.goodsTypeList = response.data.records;
    });
    this.listQuery.prepaidStatus = this.prepaidStatus;
    this.findList();
    this.management_search_button = getLimit("management_search_button");
    this.management_detail_button = getLimit("management_detail_button");
    this.management_shipment_button = getLimit("management_shipment_button");
    this.management_money_button = getLimit("management_money_button");
    this.management_oil_button = getLimit("management_oil_button");
    this.management_blank_button = getLimit("management_blank_button");
    this.management_cash_button = getLimit("management_cash_button");
    this.prepaidManagement_payOnline_button = getLimit(
      "prepaidManagement_payOnline_button"
    );
  },
  methods: {
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    updateSelectedFeeSum() {
      const records = this.$refs.xTable
        ? this.$refs.xTable.getCheckboxRecords()
        : [];
      this.selectedShipmentDeliveryFeePracticalSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "payAmount")
        : records.reduce((acc, r) => acc + Number(r.payAmount || 0), 0);
    },
    getSelectEvent() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      console.log("选择订单=======", checkedRowArray);

      if (checkedRowArray.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      }
      let branchCode = checkedRowArray[0].branchCode;
      let shipmentCode = checkedRowArray[0].shipmentCode;
      let paymentType = checkedRowArray[0].paymentType;
      if (checkedRowArray.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        let arrcarcode = [];
        for (let subItem of checkedRowArray) {
          if (paymentType == "arpa" && subItem.branchCode != branchCode) {
            this.$message.warning("请选择同一机构");
            return false;
          }
          if (paymentType == "arpa" && subItem.shipmentCode != shipmentCode) {
            this.$message.warning("请选择同一托运人");
            return false;
          }
          arrcarcode.push(subItem.code);
        }
        let codes = arrcarcode.join(",");
        console.log("codes=======", codes);
        // if (paymentType == "arpa") {
        //   this.realpay(codes);
        // } else {
        // this.businessClick(codes);
        // }

        this.ReloadingShipmentMoney({ code: codes }, paymentType);
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        // 子公司运单管理
        let api = this.$route.path.includes("sub_management")
          ? querySubList
          : orderDetailListAll;
        api(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;

          this.tableData.forEach(item => {
            item.weight = item.weight + item.coalUnitName;
            item.loadQuantity = item.loadQuantity + item.coalUnitName;
            item.unloadQuantity = item.unloadQuantity + item.coalUnitName;
          });
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 装货/收获地址
    changeAreaList(value, prefix) {
      if (value.length > 0) {
        this.listQuery[`${prefix}SubdivisionCode`] = value[2];
      } else {
        this.listQuery[`${prefix}SubdivisionCode`] = "";
      }
    },
    // 货物类型
    handleChangeCoalType(value) {
      if (value.length > 0) {
        var newValue = value.slice(0);
        this.listQuery.coalType = newValue.pop();
      } else {
        this.listQuery.coalType = "";
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 银行卡支付
    ReloadingBlank(item) {
      this.parentData.payeeCode = item.payeeCode;
      this.parentData.orderDetailCode = item.code;
      this.parentData.branchCode = item.branchCode;
      this.parentData.orderDetailNumber = item.orderCode;
      this.$refs.payadvanceBlank.show(item);
    },
    // 在线支付
    payOnline(item) {
      this.payOnlineFlag = true;
      this.$refs.payOnlineRef.show(item);
    },
    payOnlineclose() {
      this.payOnlineFlag = false;
      this.findList();
    },
    // 转账支付
    ReloadingCash(item) {
      this.parentData.payeeCode = item.payeeCode;
      this.parentData.orderDetailCode = item.code;
      this.parentData.branchCode = item.branchCode;
      this.$refs.payadvanceCash.show(item);
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    ReloadingMoney(row) {
      this.$refs.yufuMoneyRef.setFee(row);
      this.yufudelMoney = true;
    },
    close() {
      this.$refs.yufuMoneyRef.close();
    },
    ReloadingOil(row) {
      this.$refs.yufuOilRef.setFee(row);
      this.yufudelOil = true;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.total = pageSize;
      this.findList();
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    receive() {
      this.shipmentyufudelMoney = false;
      this.yufudelMoney = false;
      this.yufudelOil = false;
      this.findList();
    },
    ReloadingShipmentMoney(row) {
      preApplicationForPrepay({
        codes: row.code
      }).then(response => {
        console.log("预付信息=====", response);
        if (response.status === 0) {
          this.shipmentyufudelMoney = true;
          this.$nextTick(() => {
            this.$refs.shipmentyufuMoneyRef.init(row, response);
          });
        } else {
          this.$message({
            message: response.msg,
            type: "error"
          });
        }
      });
      return;
      this.shipmentyufudelMoney = true;
      this.$nextTick(() => {
        this.$refs.shipmentyufuMoneyRef.setFee(row);
      });
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "payAmount") {
            return this.sumObject.payAmount;
          }
          if (column.property === "payOil") {
            return this.sumObject.payOil;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style></style>
